if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.productInfo = this.closest('product-info');
        this.buttonPriceData = this.getButtonPriceData();
        this.subscriptionScopeSelector = 'subscription-widget, .shopify-block.recharge-subscription-widget, [class*="recharge"]';

        if (this.buttonPriceData) {
          this.boundUpdateSubmitButtonPrice = this.queueSubmitButtonPriceUpdate.bind(this);
          this.boundHandleSubscriptionEvent = this.handleSubscriptionEvent.bind(this);

          this.form.addEventListener('change', this.boundUpdateSubmitButtonPrice);
          this.form.addEventListener('input', this.boundUpdateSubmitButtonPrice);
          this.productInfo?.addEventListener('change', this.boundHandleSubscriptionEvent);
          this.productInfo?.addEventListener('click', this.boundHandleSubscriptionEvent);
          document.addEventListener('change', this.boundHandleSubscriptionEvent, true);
          document.addEventListener('click', this.boundHandleSubscriptionEvent, true);
          document.addEventListener('subscription-widget:init', this.boundUpdateSubmitButtonPrice);

          this.updateSubmitButtonPrice();
          this.scheduleSubmitButtonPriceUpdates([120, 320, 700, 1200, 2000, 3200, 4600]);
        }
      }

      disconnectedCallback() {
        if (!this.buttonPriceData) return;

        this.form.removeEventListener('change', this.boundUpdateSubmitButtonPrice);
        this.form.removeEventListener('input', this.boundUpdateSubmitButtonPrice);
        this.productInfo?.removeEventListener('change', this.boundHandleSubscriptionEvent);
        this.productInfo?.removeEventListener('click', this.boundHandleSubscriptionEvent);
        document.removeEventListener('change', this.boundHandleSubscriptionEvent, true);
        document.removeEventListener('click', this.boundHandleSubscriptionEvent, true);
        document.removeEventListener('subscription-widget:init', this.boundUpdateSubmitButtonPrice);

        if (this.submitButtonPriceUpdateFrame) {
          window.cancelAnimationFrame(this.submitButtonPriceUpdateFrame);
          this.submitButtonPriceUpdateFrame = null;
        }
        this.clearSubmitButtonPriceTimers();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              // publish(PUB_SUB_EVENTS.cartUpdate, {
              //   source: 'product-form',
              //   productVariantId: formData.get('id'),
              //   cartData: response,
              // });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
            
            document.dispatchEvent(new CustomEvent("cart-upsell-slider:init"));
            
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      getButtonPriceData() {
        const priceDataScript = this.querySelector('[data-product-button-price-data]');
        if (!priceDataScript) return null;

        try {
          return JSON.parse(priceDataScript.textContent);
        } catch (error) {
          console.error('Unable to parse product button price data', error);
          return null;
        }
      }

      handleSubscriptionEvent(event) {
        if (!event.target.closest(this.subscriptionScopeSelector)) return;
        this.scheduleSubmitButtonPriceUpdates([0, 150, 350]);
      }

      queueSubmitButtonPriceUpdate() {
        if (this.submitButtonPriceUpdateFrame) return;
        this.submitButtonPriceUpdateFrame = window.requestAnimationFrame(() => {
          this.submitButtonPriceUpdateFrame = null;
          this.updateSubmitButtonPrice();
        });
      }

      scheduleSubmitButtonPriceUpdates(delays = [0]) {
        this.clearSubmitButtonPriceTimers();
        this.submitButtonPriceTimers = delays.map((delay) =>
          window.setTimeout(this.boundUpdateSubmitButtonPrice, delay)
        );
      }

      clearSubmitButtonPriceTimers() {
        if (!this.submitButtonPriceTimers) return;
        this.submitButtonPriceTimers.forEach((timerId) => window.clearTimeout(timerId));
        this.submitButtonPriceTimers = [];
      }

      getSelectedSellingPlanId() {
        const formId = this.form?.id;
        const formSelector = formId ? `[form="${formId}"]` : '';
        const input =
          this.form.querySelector('[name="selling_plan"], [name="selling_plan_id"]') ||
          this.productInfo?.querySelector(
            `[name="selling_plan"]${formSelector}, [name="selling_plan_id"]${formSelector}`
          ) ||
          this.productInfo?.querySelector('[name="selling_plan"], [name="selling_plan_id"]');

        const value = `${input?.value || ''}`.trim();
        if (!value) return '';
        if (/^\d+$/.test(value)) return value;
        return value.match(/(\d+)(?!.*\d)/)?.[1] || value;
      }

      getRechargeScope() {
        return (
          this.productInfo?.querySelector('subscription-widget') ||
          this.productInfo?.querySelector('.shopify-block.recharge-subscription-widget') ||
          this.productInfo?.querySelector('[class*="recharge"]') ||
          this.productInfo
        );
      }

      isSubscriptionSelectedInWidget() {
        const scope = this.getRechargeScope();
        if (!scope) return false;
        if (scope.querySelector('.recharge-widget.selected')) return true;

        const activeOption =
          scope.querySelector('input[type="radio"]:checked') ||
          scope.querySelector('[aria-checked="true"], .active, .is-active, .selected');
        if (!activeOption) return false;

        const context = activeOption.closest('label, [role="radio"], .recharge-widget, .rc-option') || activeOption;
        const text = `${activeOption.value || ''} ${activeOption.name || ''} ${activeOption.id || ''} ${
          context.textContent || ''
        }`.toLowerCase();

        if (text.includes('one-time') || text.includes('onetime')) return false;
        return text.includes('subscr');
      }

      getCurrentVariantPricing() {
        const variantId = `${this.variantIdInput?.value || ''}`.trim();
        if (!variantId) return null;
        return this.buttonPriceData?.variants?.[variantId] || null;
      }

      getSubscriptionPricing(variantPricing, selectedSellingPlanId) {
        const sellingPlans = variantPricing?.selling_plans || {};
        if (selectedSellingPlanId && sellingPlans[selectedSellingPlanId]) return sellingPlans[selectedSellingPlanId];
        const firstSellingPlanId = Object.keys(sellingPlans)[0];
        return firstSellingPlanId ? sellingPlans[firstSellingPlanId] : null;
      }

      applyPricingToElement(priceElement, pricing = {}) {
        if (!priceElement || !pricing.price) return;

        const displayPrice = pricing.price;
        const compareAtPrice = pricing.compare_at_price || '';
        const isOnSale = Boolean(pricing.is_on_sale && compareAtPrice);

        Array.from(priceElement.querySelectorAll('.price__regular .price-item--regular'))
          .filter((node) => !node.closest('s'))
          .forEach((node) => {
            node.innerHTML = displayPrice;
          });

        const salePriceElement = priceElement.querySelector('.price__sale .price-item--sale');
        if (salePriceElement) salePriceElement.innerHTML = displayPrice;

        priceElement.querySelectorAll('s .price-item--regular').forEach((node) => {
          node.innerHTML = compareAtPrice || displayPrice;
        });

        priceElement.classList.toggle('price--on-sale', isOnSale);
      }

      updateSubmitButtonPrice() {
        if (!this.buttonPriceData || !this.submitButton) return;

        const variantPricing = this.getCurrentVariantPricing();
        if (!variantPricing) return;

        const onetimePriceElement = this.submitButton.querySelector('[js-onetime-price]');
        const subscriptionPriceElement = this.submitButton.querySelector('[js-subs-price]');
        if (!onetimePriceElement && !subscriptionPriceElement) return;

        if (onetimePriceElement && variantPricing.one_time) {
          this.applyPricingToElement(onetimePriceElement, variantPricing.one_time);
        }

        const selectedSellingPlanId = this.getSelectedSellingPlanId();
        const subscriptionPricing = this.getSubscriptionPricing(variantPricing, selectedSellingPlanId);

        if (subscriptionPriceElement && subscriptionPricing) {
          this.applyPricingToElement(subscriptionPriceElement, subscriptionPricing);
        }

        if (!onetimePriceElement || !subscriptionPriceElement) return;

        const isSubscriptionSelected = Boolean(selectedSellingPlanId) || this.isSubscriptionSelectedInWidget();

        if (isSubscriptionSelected) {
          onetimePriceElement.classList.add('hidden');
          subscriptionPriceElement.classList.remove('hidden');
        } else {
          onetimePriceElement.classList.remove('hidden');
          subscriptionPriceElement.classList.add('hidden');
        }
      }
    }
  );
}
